// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.status__active--lading-page {\n    background-color: gray;\n    padding: 6px 20px;\n    color: #fff !important;\n    border-radius: 10px;\n    line-height: 1;\n}\n", ""]);
// Exports
module.exports = exports;
